<template>
  <div>
    <p class="text-muted small mb-4 pb-2">
      {{ $t('global.modals.markdown.description') }}
    </p>

    <strong class="d-inline-block mb-3">
      {{ $t('global.modals.markdown.example') }}
    </strong>

    <table class="table-format">
      <thead>
        <tr>
          <th>{{ $t('global.modals.markdown.you_write') }}</th>
          <th>{{ $t('global.modals.markdown.you_see') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ $t('global.modals.markdown.list.title_1.html') }}</td>
          <td>
            <span class="h1">{{ $t('global.modals.markdown.list.title_1.markdown') }}</span>
          </td>
        </tr>
        <tr>
          <td>{{ $t('global.modals.markdown.list.cursive.html') }}</td>
          <td>
            <i>{{ $t('global.modals.markdown.list.cursive.markdown') }}</i>
          </td>
        </tr>
        <tr>
          <td>{{ $t('global.modals.markdown.list.bold.html') }}</td>
          <td>
            <b>{{ $t('global.modals.markdown.list.bold.markdown') }}</b>
          </td>
        </tr>
        <tr>
          <td>{{ $t('global.modals.markdown.list.strikethrough.html') }}</td>
          <td>
            <s>{{ $t('global.modals.markdown.list.strikethrough.markdown') }}</s>
          </td>
        </tr>
        <tr>
          <td>
            <b-row>
              <b-col cols="12" offset="0">
                {{ $t('global.modals.markdown.list.list.html') }}
              </b-col>
              <b-col cols="12" offset="1">
                {{ $t('global.modals.markdown.list.list.html') }}
              </b-col>
              <b-col cols="12" offset="2">
                {{ $t('global.modals.markdown.list.list.html') }}
              </b-col>

              <b-col cols="12" class="small text-muted mt-3">
                {{ $t('global.modals.markdown.list.list.note') }}
              </b-col>
            </b-row>
          </td>
          <td>
            <ul>
              <li>
                {{ $t('global.modals.markdown.list.list.markdown') }}
                <ul>
                  <li>
                    {{ $t('global.modals.markdown.list.list.markdown') }}
                    <ul>
                      <li>
                        {{ $t('global.modals.markdown.list.list.markdown') }}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>
            <span data-cy="markdown-link">
              {{ $t('global.link_example.html') }}
            </span>
          </td>
          <td>
            <SLink data-cy="rendered-link"
                   :href="$t('global.link_example.url')"
                   class="mb-0"
            >{{
              $t('global.link_example.markdown')
            }}</SLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SduiMarkdownModal',
}
</script>

<style scoped lang="scss">
.table-format {
  color: $color-black;

  th {
    background: $color-secondary;
  }

  th,
  td {
    border: 1px solid $color-gray-100;
    padding: 12px;
    width: 50%;
  }
}
</style>
